import React from 'react';
import { SolutionViewMode } from '../../../pages/Solution/Solution.component';
import { useStyles } from './Summary.styles';

interface SummaryProps {
  mode: SolutionViewMode;
  maxTotalScore: number;
  totalScore: number | null;
}

export const Summary: React.FC<SummaryProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.header}>Suma</div>
      <div className={classes.buttonOutline}>
        {props.mode === SolutionViewMode.sampleAssessmentGroupAssignment || props.totalScore === null
          ? '- '
          : props.totalScore}
        /{props.maxTotalScore}
      </div>
    </>
  );
};
